export const PRODUCT_OVERLAY_COPY = {
	title: {
		add: 'Add product',
		edit: 'Edit product',
	},
	submit: {
		add: 'Add',
		edit: 'Save',
	},
	description:
		'Provide enough product detail so we can populate listings, safety documentation, and recall scripts.',
	fields: {
		nameLabel: 'What do you call this product or family?',
		skuLabel: 'What internal SKU or identifier should we use?',
		skuDescription: 'Optional — helps reconcile listings and ERP data.',
		categoryLabel: 'Which category best describes the product?',
		categoryOtherLabel: 'How would you describe this category?',
		professionalUseLabel: 'Is this sold to consumers or professionals only?',
		statusLabel: 'What is the regulatory status?',
	},
}
